'use client'

import AnimatedNumber from './AnimatedNumber'

type AnimatedCurrencyProps = {
  end: number
  className?: string
  delay?: number
  compact?: boolean
  loop?: boolean
  loopPause?: number
}

const AnimatedCurrency = ({
  end,
  className,
  delay = 0,
  compact = false,
  loop = false,
  loopPause = 3500,
}: AnimatedCurrencyProps) => {
  const isNegative = end < 0
  const absEnd = Math.abs(end)

  return (
    <AnimatedNumber
      end={absEnd}
      className={className}
      delay={delay}
      prefix={isNegative ? '−$' : '$'}
      compact={compact}
      loop={loop}
      loopPause={loopPause}
    />
  )
}

export default AnimatedCurrency
